import 'react-circular-progressbar/dist/styles.css';

import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import Tooltip from 'components/rich/tooltip';

const COLOR = {
  DEFAULT: 'lightgray',
  ERROR: 'red',
  WARNING: 'orange',
  SUCCESS: 'green',
};

const PhotoQuality = props => {
  let pathColor = COLOR.WARNING;

  const value = props.value / props.bestDPI;
  if (props.value < props.minDPI) {
    pathColor = COLOR.ERROR;
  } else if (props.value < props.bestDPI) {
    pathColor = COLOR.WARNING;
  } else {
    return null;
  }

  return (
    <div className={props.className}>
      <Tooltip text={`${parseInt(props.value, 10)} DPI`}>
        <div style={{ maxWidth: 30 }}>
          <CircularProgressbar
            value={1 - value}
            strokeWidth={50}
            maxValue={1}
            styles={buildStyles({
              strokeLinecap: 'butt',
              backgroundColor: COLOR.DEFAULT,
              pathColor,
            })}
          />
        </div>
      </Tooltip>
    </div>
  );
};

PhotoQuality.propTypes = {
  value: PropTypes.number,
  minDPI: PropTypes.number,
  bestDPI: PropTypes.number,
  className: PropTypes.string,
};

PhotoQuality.defaultProps = {
  value: 0,
  minDPI: 72,
  bestDPI: 300,
};

export default PhotoQuality;
